/**
 * @description - creates a DunamicList<number> of numbers indexed by the same number
 * @param startYear - first number available in generated list
 * @param endYear - last number
 */
export const generateYearList = (startYear, endYear) => {
    const result = [];
    for (let i = startYear; i <= endYear; i += 1) {
        result.push({
            id: i,
            title: i,
        });
    }
    return result;
};
export const defaultTranslation = {
    dayLabel: 'Day',
    dayPlaceholder: 'Choose birthdate',
    monthLabel: 'Month',
    monthPlaceholder: 'Choose birth month',
    yearLabel: 'Year',
    yearPlaceholder: 'Choose birth year',
    validationIsRequired: 'Mandatory information',
};
export const defaultDaysList = [
    {
        id: 1,
        title: 1,
    },
    {
        id: 2,
        title: 2,
    },
    {
        id: 3,
        title: 3,
    },
    {
        id: 4,
        title: 4,
    },
    {
        id: 5,
        title: 5,
    },
    {
        id: 6,
        title: 6,
    },
    {
        id: 7,
        title: 7,
    },
    {
        id: 8,
        title: 8,
    },
    {
        id: 9,
        title: 9,
    },
    {
        id: 10,
        title: 10,
    },
    {
        id: 11,
        title: 11,
    },
    {
        id: 12,
        title: 12,
    },
    {
        id: 13,
        title: 13,
    },
    {
        id: 14,
        title: 14,
    },
    {
        id: 15,
        title: 15,
    },
    {
        id: 16,
        title: 16,
    },
    {
        id: 17,
        title: 17,
    },
    {
        id: 18,
        title: 18,
    },
    {
        id: 19,
        title: 19,
    },
    {
        id: 20,
        title: 20,
    },
    {
        id: 21,
        title: 21,
    },
    {
        id: 22,
        title: 22,
    },
    {
        id: 23,
        title: 23,
    },
    {
        id: 24,
        title: 24,
    },
    {
        id: 25,
        title: 25,
    },
    {
        id: 26,
        title: 26,
    },
    {
        id: 27,
        title: 27,
    },
    {
        id: 28,
        title: 28,
    },
    {
        id: 29,
        title: 29,
    },
    {
        id: 30,
        title: 30,
    },
    {
        id: 31,
        title: 31,
    },
];
export const defaultMonthsList = [
    {
        id: 0,
        title: 'January',
    },
    {
        id: 1,
        title: 'February',
    },
    {
        id: 2,
        title: 'March',
    },
    {
        id: 3,
        title: 'April',
    },
    {
        id: 4,
        title: 'May',
    },
    {
        id: 5,
        title: 'June',
    },
    {
        id: 6,
        title: 'July',
    },
    {
        id: 7,
        title: 'August',
    },
    {
        id: 8,
        title: 'September',
    },
    {
        id: 9,
        title: 'October',
    },
    {
        id: 10,
        title: 'November',
    },
    {
        id: 11,
        title: 'December',
    },
];
export const defaultYearList = generateYearList(1913, new Date().getFullYear());
export const defaultBirthDateOptions = {
    daysList: defaultDaysList,
    monthsList: defaultMonthsList,
    yearList: defaultYearList,
};
export const defaultBirthDateErrors = {
    day: false,
    month: false,
    year: false,
};
//# sourceMappingURL=defaultValues.js.map